import { StandardEvents, CartLinesUpdateEvent } from '@shopify/events';
// All totals/discounts come from Shopify's rendered cart, never a client-side pricing formula.
// 21/10 : latence. Chaque action = 1 requête (change/update renvoient le panier ET la section rendue
// grâce au paramètre `sections`), au lieu de 4 en série ; retour visuel immédiat (optimiste) avant la réponse.
const SECTION = 'cart-drawer-section';
const rootURL = window.Shopify?.routes?.root || '/';
const drawer = () => document.getElementById('cart-drawer');
const content = () => drawer()?.querySelector('.eciso');
let changing = false, refreshSequence = 0, skipOpenRefresh = false;
async function request(path, body) {
 const response = await fetch(rootURL + path, {method: 'POST', headers: {'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({...body, sections: SECTION})});
 const data = await response.json();
 if (!response.ok) throw new Error(data.description || data.message || 'Please try again.');
 return data;
}
function render(html) {
 const doc = new DOMParser().parseFromString(html, 'text/html');
 const next = doc.querySelector('.eciso'), current = content();
 if (!next || !current) return false;
 const position = current.querySelector('.eciso-scroll')?.scrollTop || 0;
 current.replaceWith(next);
 const scroll = next.querySelector('.eciso-scroll'); if (scroll) scroll.scrollTop = position;
 syncProtection();
 const count = Number(next.dataset.isoCount || 0);
 document.querySelectorAll('#vlp-cartn').forEach(el => el.textContent=String(count));
 document.querySelectorAll('cart-icon').forEach(icon=>icon.renderCartBubble?.(count,false));
 document.dispatchEvent(new CustomEvent('vlp:cart-updated', {detail:{item_count:count}}));
 return true;
}
async function refresh() {
 const sequence = ++refreshSequence;
 if (!changing) content()?.setAttribute('aria-busy','true');
 try {
  const response = await fetch(rootURL + '?section_id=' + SECTION, {cache:'no-store'});
  if (!response.ok) throw new Error('Unable to refresh your cart. Please try again.');
  const html = await response.text();
  if (sequence !== refreshSequence) return;
  render(html);
 } finally { if (!changing) content()?.removeAttribute('aria-busy'); }
}
function syncProtection() {
 const toggle=content()?.querySelector('[data-iso-protection]');
 if(toggle) toggle.setAttribute('aria-pressed', String(!window.ecProtect?.isOff()));
}
function showError(message) { const el=content()?.querySelector('.eciso-error'); if(el){el.hidden=false;el.textContent=message;} }
const isCart = d => d && Array.isArray(d.items) && typeof d.total_price === 'number';
async function change(task) {
 if(changing) return;
 changing=true;content()?.setAttribute('aria-busy','true');
 try {
  const data = await task();
  // change.js / update.js renvoient le panier complet ; add.js seulement les lignes ajoutées.
  let c = isCart(data) ? data : await (await fetch(rootURL+'cart.js',{cache:'no-store'})).json();
  let html = data && data.sections && data.sections[SECTION];
  // Reprice an existing protection line when crossing a tier. Never retain paid extras alone.
  const merchandise=c.items.filter(i=>!['shipping-protection-1','essential-cart-order-upsell-default'].includes(i.handle));
  if(!merchandise.length && c.items.length){const updates={};c.items.forEach(i=>updates[i.key]=0);const d=await request('cart/update.js',{updates});html=d.sections&&d.sections[SECTION];}
  else if(window.ecProtect && merchandise.length){ const r=await window.ecProtect.ensure(c); if(r) html=(r.sections&&r.sections[SECTION])||null; }   // ajoute ou retarife la protection dès qu'il y a un article (comme le tiroir de Emma's)
  if(html){ ++refreshSequence; render(html); } else { await refresh(); }
 } catch(error){ try { await refresh(); } catch(e) {} showError(error.message || 'Please try again.'); }
 finally {changing=false;content()?.removeAttribute('aria-busy');}
}
document.addEventListener('click',event=>{
 const target=event.target.closest?.('[data-iso-close],[data-iso-change],[data-iso-add],[data-iso-warranty],[data-iso-protection],[data-iso-prev],[data-iso-next]');
 if(!target || !drawer()?.contains(target)) return;
 event.preventDefault();
 if(target.hasAttribute('data-iso-close')) {drawer()?.close();return;}
 if(target.hasAttribute('data-iso-prev') || target.hasAttribute('data-iso-next')) {
  const section=target.closest('.eciso-upsell'),cards=[...section.querySelectorAll('[data-iso-page]')];
  const current=Number(section.dataset.page||0),last=Math.max(0,...cards.map(c=>Number(c.dataset.isoPage)));
  const next=(current+(target.hasAttribute('data-iso-next')?1:-1)+last+1)%(last+1);
  section.dataset.page=String(next);cards.forEach(c=>c.hidden=Number(c.dataset.isoPage)!==next);return;
 }
 if(changing) return;
 if(target.hasAttribute('data-iso-change')) {
  const key=target.closest('[data-iso-key]').dataset.isoKey, quantity=Number(target.dataset.isoChange);
  // Retour immédiat : nouvelle quantité affichée, ligne estompée si suppression.
  const qty=target.closest('.eciso-quantity')?.querySelector('span'); if(qty) qty.textContent=String(quantity);
  if(quantity===0) target.closest('li, .eciso-item')?.classList.add('is-removing');
  change(()=>request('cart/change.js',{id:key,quantity}));return;
 }
 if(target.hasAttribute('data-iso-add')) {target.disabled=true;target.textContent='Adding…';change(()=>request('cart/add.js',{items:[{id:Number(target.dataset.isoAdd),quantity:1}]}));return;}
 if(target.hasAttribute('data-iso-warranty')) {
  const key=target.dataset.isoKey, pressed=target.getAttribute('aria-pressed')==='true';
  target.setAttribute('aria-pressed', String(!pressed)); target.classList.add('is-pending');
  // update.js (quantité absolue) renvoie le panier complet + la section : une seule requête pour ajouter comme pour retirer.
  const updates={}; updates[key||String(target.dataset.isoWarranty)]=pressed?0:1;
  change(()=>request('cart/update.js',{updates}));return;
 }
 if(target.hasAttribute('data-iso-protection')) {
  const selected=target.getAttribute('aria-pressed')==='true';
  target.setAttribute('aria-pressed', String(!selected)); target.classList.add('is-pending');
  change(async()=>{if(!window.ecProtect) throw new Error('Please reload to update shipping protection.');window.ecProtect.setOff(selected);const r=selected?await window.ecProtect.remove():await window.ecProtect.ensure();return isCart(r)?r:null;});
 }
});
document.addEventListener('theme-drawer:open',event=>{if(event.target!==drawer())return;if(skipOpenRefresh){skipOpenRefresh=false;return;}refresh().catch(e=>showError(e.message));});
// Ajout depuis une fiche produit (Horizon) : on rend la section, puis on pose la protection colis au bon palier.
document.addEventListener(StandardEvents.cartLinesUpdate,event=>{event.promise?.then(async()=>{let r=false;try{r=window.ecProtect?await window.ecProtect.ensure():false;}catch(e){}if(r&&r.sections&&r.sections[SECTION]){++refreshSequence;render(r.sections[SECTION]);}else await refresh();}).catch(()=>{});});
// Collection headers are outside Horizon's normal header; use the same public drawer API.
document.addEventListener('click',event=>{
 const link=event.target.closest?.('#vlp-cartbtn,[data-testid="cart-drawer-trigger"]');if(!link||!drawer())return;
 event.preventDefault();event.stopImmediatePropagation();skipOpenRefresh=true;drawer()?.open();refresh().catch(error=>showError(error.message));   // ouvre tout de suite, rafraîchit derrière
},true);
window.emmaISOCart={refresh,open:()=>drawer()?.open()};
syncProtection();

// Submit the selected gift box with the product in one request. A checkbox alone never charges it.
window.addEventListener('submit',async event=>{
 const form=event.target;
 if(!(form instanceof HTMLFormElement) || !form.closest('product-form-component'))return;
 const section=form.closest('.shopify-section');
 const checkbox=section?.querySelector('.ec-addon__check:checked');
 if(!checkbox)return;
 event.preventDefault();event.stopImmediatePropagation();
 if(form.dataset.ecGiftBusy)return;
 const data=new FormData(form),id=Number(data.get('id')),gift=Number(checkbox.closest('.ec-addon').dataset.variant);
 if(!id||!gift)return;
 form.dataset.ecGiftBusy='true';const button=event.submitter; if(button)button.disabled=true;
 const item={id,quantity:Number(data.get('quantity')||1)},properties={};
 if(data.get('selling_plan'))item.selling_plan=String(data.get('selling_plan'));
 for(const [key,value] of data.entries()){const match=key.match(/^properties\[(.+)\]$/);if(match && typeof value==='string')properties[match[1]]=value;}
 if(Object.keys(properties).length)item.properties=properties;
 try {
  await request('cart/add.js',{items:[{id:gift,quantity:1},item]});
  const c=await (await fetch(rootURL+'cart.js',{cache:'no-store'})).json();
  await refresh();drawer()?.open();
  document.dispatchEvent(new CartLinesUpdateEvent({action:'add',context:'product',lines:[{merchandiseId:String(id),quantity:item.quantity},{merchandiseId:String(gift),quantity:1}],promise:Promise.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(c),detail:{itemCount:c.item_count,items:c.items,source:'emma-gift-addon',didError:false}})}));
 }catch(error){let message=section.querySelector('.ec-gift-error');if(!message){message=document.createElement('p');message.className='ec-gift-error';message.setAttribute('role','alert');checkbox.closest('.ec-addon').append(message);}message.textContent=error.message;}
 finally{delete form.dataset.ecGiftBusy;if(button)button.disabled=false;}
},true);

window.addEventListener('pageshow',()=>{if(drawer()?.hasAttribute('open'))refresh().catch(()=>{});});
if(drawer()?.hasAttribute('open'))refresh().catch(()=>{});
